import { useState } from 'react';

import useStores from 'hooks/useStores';
import useModal from 'hooks/useModal';

import Button from 'components/@common/Button';
import CardItemList from 'components/CardItemList';

import { CARD_EDIT_TARGET_INDEX, PAGE_LIST } from 'constants/';
import * as S from './styles';

import CardEditConfirm from './Containers/CardEditConfirm';

function CardList() {
  const [focusCardIndex, setCardFocus] = useState(-1);

  const {
    Modal: EditModal,
    modalOpen: handleEditModalOpen,
    modalClose: handleEditModalClose,
  } = useModal();

  const { AppHandler, CardWallet } = useStores();

  const onClickCard = (index) => {
    setCardFocus(index);
    handleEditModalOpen();
  };

  const onClickAddButton = () => {
    CardWallet.setEditCardIndex(CARD_EDIT_TARGET_INDEX.NEW);
    AppHandler.setAppLocation(PAGE_LIST.CARD_EDITOR);
  };

  const onClickHomeButton = () => {
    AppHandler.setAppLocation(PAGE_LIST.CARD_PAYMENT);
  };

  return (
    <>
      <div className="layout-side-container">
        <CardItemList onClickCard={onClickCard} />
      </div>

      <div className="layout-main-container bottom">
        <S.ButtonAddCard onClick={onClickAddButton}>
          <div className="icon">➕</div>
          <p className="text">새로운 카드 추가</p>
        </S.ButtonAddCard>

        <Button type="primary" width="100%" onClick={onClickHomeButton}>
          결제 화면으로 이동
        </Button>
      </div>

      <EditModal>
        <CardEditConfirm
          focusCardIndex={focusCardIndex}
          onClickCloseButton={handleEditModalClose}
        />
      </EditModal>
    </>
  );
}

export default CardList;
